










import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';


@Component({
    components: { }
})
export default class Warranty extends ListBase {
    
    get warrantyUrl() {
        return Util.abp.setting.get('WARRANTY_LINK');
    };

    mounted() {
        window.open(Util.abp.setting.get('WARRANTY_LINK'));
        this.$router.go(-1);
    }

    created() {
    }
}
